const isReferralRequired = {
    'question': 'Czy aby umówić się na wizytę w Colligo, potrzebne jest skierowanie?',
    'answer': 'Nie, aby umówić wizytę w naszym centrum psychiatrii i psychoterapii nie jest potrzebne skierowanie. Oferujemy otwarty dostęp do specjalistów i szybkie terminy bez konieczności wcześniejszego uzyskania skierowania.',
}

export default isReferralRequired;